export default {
  filters: {
    intToDecimal(val, beforeFloat = false, afterFloat = false) {
      let res = parseFloat((val / 100).toFixed(2)).toLocaleString("pt-br", {
        minimumFractionDigits: 2
      });
      let splitted = res.split(",");

      if (beforeFloat) return splitted[0];
      if (afterFloat) return splitted[1];

      return res;
    },

    intToCurrency(val, currency = "R$ ") {
      return (
        currency +
        parseFloat((val / 100).toFixed(2)).toLocaleString("pt-br", {
          minimumFractionDigits: 2
        })
      );
    },

    withZeros(number, length = 2) {
      var res = number.toString();

      while (res.length < length) {
        res = "0" + res;
      }

      return res;
    }
  },
  methods: {
    removeCurrencySeparators(val) {
      return val.replace(".", "").replace(",", "");
    },
    currencyInCents(val) {
      let value =
        typeof val === "string"
          ? parseInt(this.removeCurrencySeparators(val))
          : Math.round(val.toFixed(2) * 100);
      return value;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/numberMixin.js